export default __webpack_public_path__ + "static/media/A_01_01_ticker-loop_v02.7b9ffbae.mp3";